import { Component, Prop, Vue } from 'vue-property-decorator';
import store from "Store/index";
import BaseComponent from 'Components/Base/ABaseComponent';
import { mixins } from 'vue-class-component';
import Slick from 'vue-slick';

@Component({
    components:{
        Slick
    }
})
export default class ProductPageComponent extends mixins(BaseComponent) {
    
    
    async created() {
        this.setLoading();
        await store.dispatch.auth.loadUser();
        this.setLoaded();

        this.initJSSlick();
    }

    //we are lucky that 'slick' is loaded on to jquery, this means that we can use old logic to show thumbs
    initJSSlick(){
        (<any>$('#product-images')).slick({
            rows: 0,
            lazyLoad: 'ondemand',
            speed: 500,
            arrows: false,
            fade: true,
            dots: true,
            swipeToSlide: true,
            asNavFor: '#product-images-thumbs',
            slidesToShow: 1
        });
        (<any>$('#product-images-thumbs')).slick({
            rows: 0,
            slidesToShow: 3,
            slidesToScroll: 1,
            asNavFor: '#product-images',
            lazyLoad: 'ondemand',
            dots: false,
            swipeToSlide: true,
            arrows: true,
            vertical: true,
            centerMode: false,
            focusOnSelect: true,
            nextArrow: '<a href="javascript:void()" class="slick-next slick-arrow"><i class="icon-angle-down" aria-hidden="true"></a></a>',
            prevArrow: '<a href="javascript:void()" class="slick-prev slick-arrow"><i class="icon-angle-up" aria-hidden="true"></a></a>'
        });
    }
    
    
    //slick options
    
    public slickRelatedOptions: any = {
        rows: 0,
        slidesToShow: 4,
        slidesToScroll: 4,
        arrows: true,
        dots: true,
        fade: false,
        infinite: true,
        adaptiveHeight: false,
        // swipeToSlide: true,
        // appendArrows: '#related-header',
        lazyLoad: 'ondemand', //ondemand,progressive 
        // nextArrow: '<button type="button" class="slick-next slick-arrow"><i class="icon-angle-right" aria-hidden="true"></button>',
        // prevArrow: '<button type="button" class="slick-prev slick-arrow"><i class="icon-angle-left" aria-hidden="true"></button>',
        // speed: 500,
        responsive: [
            {
                breakpoint: 1025,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 4
                }
            },
            {
                breakpoint: 869,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3
                }
            },
            {
                breakpoint: 660,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    dots: false
                    //swipeToSlide: true
                }
            },
            {
                breakpoint: 410,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: false
                    //swipeToSlide: true
                }
            }
        ]
    };
    
    
}

Vue.component('product-page', ProductPageComponent);